import { Flex, Layout } from "antd";
import {
  HeaderComp,
  HeroBG,
  BrandsHome,
  FourColumnsRoundedImg,
  TwoColumnsTextLeft,
  RoundedVideo,
  TwoColumnsTextRight,
  CarouselComp
} from "../components";
import useIsMobile from '../utils/isMobile'

const { Header, Content, Footer } = Layout


const Home = () => {

  const isMobile = useIsMobile();
  return (
    <>
      <Header className="header">
        <HeaderComp />
      </Header>
      <Flex vertical>
        <Content className={!isMobile ? "global-content" : ""}>
          <HeroBG page={'home'}/>
          {!isMobile ? ( 
            <>
              <BrandsHome page={'home'} />
              <FourColumnsRoundedImg page={"home"} />
            </>
            ): (<></>)}
          <TwoColumnsTextLeft page={"home"} />
          <RoundedVideo page={"home"} />
          <TwoColumnsTextRight page={"home"} />
          <CarouselComp page={"home"}/>
        </Content>
      </Flex>
    </>
  );
};

export default Home;
